<template>
  <div class="pad30">
    <h2 class="f18 fb normal gray_2">渠道归属</h2>
    <div class="box20"></div>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <span>客户名称：</span>
        <el-input class="w210 mar20_r" placeholder="请输入客户名称" v-model.trim="searchForm.name"></el-input>
      </div>
      <div>
        <span>手机号：</span>
        <el-input class="w210 mar20_r" placeholder="请输入手机号" v-model.trim="searchForm.phone"></el-input>
      </div>
      <div>
        <span>分组名称：</span>
        <el-select class="w210 mar20_r" v-model="searchForm.groupId" placeholder="请选择">
          <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="getList">查询</el-button>
    </div>
    <el-table border :data="list" row-class-name="pointer">
      <el-table-column show-overflow-tooltip prop="name" label="客户名称" />
      <el-table-column prop="phone" label="联系电话" />
      <el-table-column prop="groupName" label="分组" />
      <el-table-column prop="channelServiceOrgName" label="渠道归属" />
      <el-table-column prop="channelServiceRebate" label="返利比例(店铺积分)">
        <template slot-scope="scope">
          <span>{{ scope.row.channelServiceRebate }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="240">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isExistChannelRevert === 1" type="danger" @click="setOrg(scope.row, 'cancel')">取消渠道</el-button>
          <el-button v-else type="primary" @click="setOrg(scope.row)">渠道设置</el-button>
          <el-button type="primary" class="mar15-l" @click="setEbate(scope.row)">返利设置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
      <el-pagination
        layout="prev, pager, next, sizes, jumper"
        background
        hide-on-single-page
        :page-size.sync="pageSize"
        :page-count="totalPage"
        :current-page.sync="pageNum"
        :page-sizes="[10, 50, 100]"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <el-dialog title="设置渠道返利" :visible.sync="ebateVisible" width="500" :close-on-click-modal="false" :show-close="false">
      <div>
        <div>渠道：{{ customer.channelServiceOrgName }}</div>
        <div class="mar20-tb">
          <span>返利比例：</span>
          <!-- 0.01-100 -->
          <!-- eslint-disable-next-line -->
          <el-input oninput="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')"
            class="w150 mar5-r"
            placeholder="请输入返利比例"
            v-model.trim="channelServiceRebate"
          ></el-input>
          <span>%</span>
        </div>
        <div>
          <div class="mar5-b">注：</div>
          <div class="mar5-b">1、返利仅支持按本客户实际支付金额的比例发放店铺积分</div>
          <div class="mar5-b">2、如比例默认为0%，如为0，则视为关系不存在</div>
          <div>3、单独设置了积分发放规则（为支付完成后发放）后，如客户触发积分规则，客户和渠道均会获取积分</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ebateVisible = false">取 消</el-button>
        <el-button type="primary" @click="ebateSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="orgDialog" title="设置归属渠道" :visible.sync="orgVisible" width="700" :close-on-click-modal="false" :show-close="false">
      <div>
        <div class="flex flex-wrap flex1 items-center mar20-b">
          <el-input :placeholder="querySel === 1 ? '请输入渠道名称' : '请输入联系方式'" v-model="orgNameOrPhone" class="input-with-select w280 mar20_r">
            <el-select v-model="querySel" slot="prepend" placeholder="请选择">
              <el-option label="企业" :value="1"></el-option>
              <el-option label="个人" :value="2"></el-option>
            </el-select>
          </el-input>
          <el-button type="primary" @click="getOrgList">查询</el-button>
        </div>
        <template v-if="querySel === 1">
          <el-table border :data="orgList" row-class-name="pointer" @selection-change="selectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column show-overflow-tooltip prop="id" label="ID" />
            <el-table-column show-overflow-tooltip prop="name" label="名称" />
            <el-table-column show-overflow-tooltip prop="state" label="状态" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 8">已认证</span>
                <span v-else>未认证</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="adminName" label="管理员" />
            <!-- <el-table-column prop="phone" label="联系电话" width="150" /> -->
          </el-table>
        </template>
        <template v-else>
          <el-table border :data="orgList" row-class-name="pointer" @selection-change="selectionChange">
            <el-table-column type="selection" width="55" />
            <el-table-column show-overflow-tooltip prop="id" label="ID" />
            <el-table-column show-overflow-tooltip prop="name" label="名称" />
            <!-- <el-table-column prop="phone" label="联系电话" width="150" /> -->
          </el-table>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orgVisible = false">取 消</el-button>
        <el-button type="primary" @click="orgSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      env: process.env,
      searchForm: {
        name: "",
        phone: "",
        groupId: "",
      },

      list: [],
      groupList: [],

      customer: {}, // 当前操作的客户

      ebateVisible: false, // 返利弹框
      channelServiceRebate: "", // 设置的返利比例

      orgVisible: false, // 返利弹框
      orgList: [],
      orgNameOrPhone: "",
      querySel: 1,
      multipleSelection: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
    this.getGroupList();
  },
  methods: {
    getGroupList() {
      this.$store.dispatch("shop/shop/getCustomerGroupList").then((data) => {
        this.groupList = data || [];
      });
    },
    getList() {
      const { pageNum, pageSize, searchForm } = this;
      const { name, phone, groupId } = searchForm;
      this.$store
        .dispatch(
          "shop/shop/listCustomer",
          this.$qs.stringify({
            name: name,
            phone: phone,
            groupId: groupId,
            pageNum,
            pageSize,
          })
        )
        .then((res) => {
          const { count = 0, data = [] } = res;
          this.list = data;
          this.pageTotal = count;
          this.totalPage = Math.ceil(count / pageSize);
        });
    },
    restList() {
      this.searchForm = {
        name: "",
        phone: "",
        groupId: "",
      };
    },
    openGoodDetail(id) {
      this.curOrderId = id;
      this.$store
        .dispatch("groupBuying/getOrderGoodsDetailList", {
          orderId: id,
        })
        .then((data) => {
          this.goodsList = data || [];
          this.goodVisible = true;
        });
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    getOrgList() {
      const { orgNameOrPhone, querySel } = this;
      if (querySel === 1) {
        this.$store
          .dispatch("shop/shop/getOrgList", {
            open_req_src: "nxmall_agr",
            name: orgNameOrPhone,
          })
          .then((res) => {
            const { data } = res;
            this.orgList = data.filter((item) => {
              return !item.group;
            });
          });
      } else if (querySel === 2) {
        this.$store
          .dispatch("app/geUserSearch", {
            open_req_src: "nxmall_agr",
            cell_phone: orgNameOrPhone,
          })
          .then((res) => {
            this.orgList = res;
          });
      }
    },
    setOrg(item, type) {
      this.customer = item;
      if (type === "cancel") {
        const { shopId, targetIdStr } = item;
        this.$confirm("您确定要取消吗？", "提示").then(() => {
          this.updateChannel(shopId, targetIdStr, 0, 0);
        });
        return;
      }
      this.orgNameOrPhone = "";
      this.orgList = [];
      this.multipleSelection = [];
      this.orgVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val || [];
    },
    orgSubmit() {
      const { customer, multipleSelection } = this;
      if (!multipleSelection.length) {
        this.$message.warning("请先选择渠道");
        return;
      }
      const { shopId, targetIdStr } = customer;
      const channelServiceOrgBoId = multipleSelection[0].id;
      this.updateChannel(shopId, targetIdStr, channelServiceOrgBoId, 0);
    },
    setEbate(item) {
      const { isExistChannelRevert } = item;
      if (isExistChannelRevert !== 1) {
        this.$message.warning("请先设置渠道");
        return;
      }
      this.customer = item;
      this.channelServiceRebate = item.channelServiceRebate || "";
      this.ebateVisible = true;
    },
    ebateSubmit() {
      const { channelServiceRebate, customer } = this;
      const { shopId, channelServiceOrgBoIdStr, targetIdStr } = customer;
      if (Number(channelServiceRebate) > 100) {
        this.$message.warning("只能设置0.01 ~ 100之间");
        return;
      }
      this.updateChannel(shopId, targetIdStr, channelServiceOrgBoIdStr, channelServiceRebate);
    },

    updateChannel(shopId, customerId, channelServiceOrgBoId, channelServiceRebate) {
      // shopId 店铺ID
      // customerId 客户ID
      // channelServiceOrgBoId 渠道组织ID
      // channelServiceRebate 返利比例

      this.$store
        .dispatch("channel/editChannelService", {
          shopId,
          customerId,
          channelServiceOrgBoId,
          channelServiceRebate,
        })
        .then((res) => {
          const { code, msg } = res;
          if (code === "0") {
            const message = channelServiceOrgBoId === 0 ? "取消成功！" : "设置成功！";
            this.$message.success(message);
            this.getList();
          } else {
            this.$message.warning(msg);
          }
          this.orgVisible = false;
          this.ebateVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>
<style>
.el-select-dropdown__item.selected {
  color: #0095f1;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0095f1;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-checkbox__inner:hover {
  border-color: #0095f1;
}
.el-input-group__prepend .el-select {
  width: 75px;
}
</style>
